import React, { useState } from 'react';
import styled from 'styled-components';
import ContactUsModal from '../../shared/components/modals/ContactUsModal';
import {
  FaBlackTie,
  FaBusinessTime,
  FaHandsHelping, FaNetworkWired,
  FaPhone, FaRegMoneyBillAlt,
  FaRocket,
  FaToolbox,
  FaTools,
  FaUsers,
  FaUserTie,
} from 'react-icons/fa';

// Styled Components
const Main = styled.main`
  max-width: 900px;
  margin: 0 auto;
  padding: 1rem;
  
`;

const ColorSection = styled.section`
  padding: 4rem 1rem; // Increased padding for more distinct sections
  background-color: ${props => props.bgColor || '#ffffff'};
 
  margin: 2rem 0; // Added margin for more separation between sections
  display: flex;
  flex-direction: column;
  align-items: center; // Centered Content
  text-align: center; // Ensure text is centered
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 1rem;
  display: flex; // Align title and icon
  align-items: center; // Center text and icon
  justify-content: center;
`;

const Paragraph = styled.p`
  color: #333;
  line-height: 1.6;
  margin-bottom: 2rem; // Increase spacing below paragraphs
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1.5rem; // Slightly bigger gap for better separation
`;

const Card = styled.div`
  border: 1px solid #ddd;
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex; // Added for internal flex layout
  flex-direction: column; // Stack items vertically
  align-items: center; // Center card content
  text-align: center; // Ensure text within is centered
   
`;

const Icon = styled.div`
  color: ${props => props.color || '#0071e1'};
  margin-right: 8px; // Ensure space between icon and title text
`;

const CardTitle = styled.h3`

  font-size: 1.5rem;
  margin-bottom: 0.5rem;
   
`;

const CardDescription = styled.p`
  color: #666;
`;


const Section = styled.section`
  margin-bottom: 2rem;
`;

const IconWrapper = styled.div`
  font-size: 2rem; // Size of icons
  margin: 1rem 0;
  color: ${props => props.iconColor || '#0071e1'}; // Allows icon color customization
`;




const SubmitFeatureRequestButton = styled.button`
  background-color: #0071e1;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #005cbf;
  }
`;

const contactOptions = [
  { label: 'Support Request', value: 'support' },
  { label: 'Other', value: 'other' },
];
// Main Content Component
const SupportPage = () => {
  const [showModal, setShowModal] = useState(false);

  const handleModalShow = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <Main>
         <ColorSection bgColor="#e9ecef">
        <Title><Icon><FaRocket /></Icon>How Can We Help?</Title>
        <Paragraph>Welcome to our support page. Here you'll find all the resources you need to make the most out of our services.</Paragraph>
      </ColorSection>

      <ColorSection >
        <Paragraph>We're dedicated to your success and ready to assist with any requests. Submit your support request, and our team will respond promptly.</Paragraph>
        <SubmitFeatureRequestButton onClick={handleModalShow}>
          <FaPhone/> Submit Support Request
        </SubmitFeatureRequestButton>
      </ColorSection>

      <ContactUsModal
        show={showModal}
        handleClose={handleModalClose}
        options={contactOptions}
        defaultReason='support'
        userLoggedIn={true}
      />
      <ColorSection>
        <Title>A comprehensive approach to your success</Title>
        <Paragraph>Everything is guided by the most important step in the product journey: Your active engagement and feedback. This critical interaction shapes our roadmap and innovations, ensuring that the solutions we develop meet your needs and exceed your expectations.</Paragraph>
      </ColorSection>

     <ColorSection>
  <Title>Meet the Team <FaHandsHelping style={{marginLeft:'10px'}}/></Title>
  <Grid>
    {teamData.map(member => (
      <Card  key={member.id}>
        <CardTitle  bgColor="#cddaf5">
          {React.createElement(member.icon, { style: { marginBottom: '10px',marginRight: '10px', fontSize: '24px' }})}
          {member.title}
        </CardTitle>
        <CardDescription>{member.description}</CardDescription>
      </Card>
    ))}
  </Grid>
</ColorSection>
      <ColorSection bgColor='#ffffff'>
        <Title>Our Commitment to You</Title>
        <Paragraph>Our team is committed to providing exceptional service and support. We look forward to helping you
          achieve your goals!</Paragraph>
        <IconWrapper iconColor='#28a745'>
          <FaBusinessTime />
        </IconWrapper>
      </ColorSection>
    </Main>
  );
};

// Sample data for the team section
const teamData = [
  {
    id: 1,
    title: 'Professional Services',
    description: 'We promote product adoption and accelerate time to value through tailored onboarding, training, and education.',
    icon: FaUserTie
  },
  {
    id: 2,
    title: 'Customer Success',
    description: 'We proactively engage with you throughout our partnership to ensure you are achieving your goals.',
    icon: FaUsers
  },
  {
    id: 3,
    title: 'Technical Success',
    description: 'We minimize business disruption by providing technical guidance to quickly overcome any product issues.',
    icon: FaTools
  },
  {
    id: 4,
    title: 'Subscription Success',
    description: 'We optimize your subscription to deliver results. Together, we deepen our partnership to further your ability to achieve key business outcomes.',
    icon: FaRegMoneyBillAlt
  },
  {
    id: 5,
    title: 'Technical Account Management',
    description: 'We provide guidance on technical infrastructure, deployment planning, product roadmap, and issue resolution.',
    icon: FaNetworkWired
  },
  {
    id: 6,
    title: 'Sales',
    description: 'We understand your challenges, value drivers, and desired outcomes. We recommend the best solutions to help you achieve your goals.',
    icon: FaBlackTie
  }
  // Add other team members as necessary
];

export default SupportPage;